export default "__VITE_ASSET__B5xTWvg8__"